<template>
  <div class="home">
    <el-tabs type="border-card" class="fullHeight">
      <el-tab-pane class="paddingBody" :label="$t('Tarea')" v-loading="saveLoading"
        element-loading-text="Guardando sus cambios ...">
        <el-row>
          <el-col :md="24">
            <StepsInventario v-bind:step="1" />
          </el-col>
        </el-row>
        <br>
        <el-row>
          <el-col :md="24">
            <h2 style="margin-bottom: 0px;">Tarea
              <br>
              <h1 style="font-size: 16px;" class="nameTask">{{ taskName }}</h1>
            </h2>
          </el-col>
        </el-row>
        <br>
        <el-row>
          <el-col :md="24">
            <h3>{{ $t('Definir Procedimiento de Trabajo') }}</h3>
            <el-alert v-if="required" show-icon type="warning" :closable="false" class="p-20 mb-20">
              {{ $t('La tarea') }} <b>"{{ taskName }}"</b> {{ $t('contiene') }}
              <b>{{ risksHigher.length }}</b> {{ $t('riesgos de valor MFL') }}
              {{ rule.mfl }} o superior y/o valor RRR (NSR) {{ rule.rrr }}
              {{ $t('o superior, por lo que es obligatorio definir procedimiento de trabajo.') }}
            </el-alert>
            <el-alert v-else type="info" :closable="false" class="p-20 mb-20">
              {{ $t('La tarea') }} <b class="s-1">"{{ taskName }}"</b> {{ $t('no contiene') }}
              {{ $t('riesgos de valor MFL') }} {{ rule.mfl }} {{ $t('o superior y/o valor RRR (NSR)') }} {{ rule.rrr }}
              {{ $t('o superior, por lo que definir procedimiento de trabajo es opcional.') }}
            </el-alert>
          </el-col>
          <el-col :md="24">
            <br>
            <el-input type="textarea" :rows="2" v-model="procedure" :placeholder="$t('Procedimiento')">
            </el-input>
            <el-alert show-icon style="margin-top: 20px;" type="info">
              Para definir un procedimiento en esta sesión: en el campo de texto de a arriba debe señalar el nombre del
              procedimiento a utilizar en la tarea,
              una vez agregado el o los procedimientos asociados a su tarea debe presionar el botón "<b>Siguiente</b>"
              para continuar.
            </el-alert>
          </el-col>
        </el-row>
        <el-row>
          <el-col :md="24">
            <br><br>
            <div class="text-right">
              <el-button @click="previousStep" size="medium" type="info" class="big-submit">
                {{ $t('Anterior') }}
              </el-button>
              <el-button type="primary" :disabled="(this.required && !this.status)" :loading="isLoading" @click="nextStep"
                size="medium" class="big-submit">
                {{ $t('Siguiente') }}
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import StepsInventario from '@/components/StepsInventario.vue';
import axios from "axios";

export default {
  name: 'ThirdStep',
  data() {
    return {
      saveLoading: false,
      isLoading: false,
      activeTab: 'table',
      risksHigher: [],
      required: false,
      status: false,
      procedure: '',
      procedureRules: {
        '5a6f78337b772dcfe68241d5': { mfl: 4, rrr: 10 },
        default: { mfl: 3, rrr: 90 },
      },
      rule: { mfl: 3, rrr: 10 },
    };
  },
  watch: {
    procedure(newVal, oldVal) {
      this.setStatus();
    },
  },
  components: {
    StepsInventario,
  },
  computed: {
    taskName() {
      const indexTask = this.$store.getters.selectedIndexTask;
      return this.$store.getters.inventario.tareas[indexTask].nombre;
    },
    ...mapGetters({
      isLoggedIn: 'isLoggedIn',
    }),
  },
  async created() {
    await this.setProcedure();
    await this.setProcedureRule();
    await this.risksRuleValidation();
    await this.setStatus();
  },
  methods: {
    async updateTask(data, id_tarea) {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      this.saveLoading = true;
      var resp = await axios.post(`/inventarios/updateTask`, {
        id_inventario: this.$store.getters.inventario._id,
        data: data,
        id_tarea: id_tarea
      }, config);

      if (resp.data.status === true) {
        this.saveLoading = false;
        this.$notify({
          duration: 3000,
          title: "Atención",
          message: "Tarea actualizada exitosamente",
          type: "success",
        });
      } else {
        this.saveLoading = false;
        this.$notify({
          duration: 3000,
          title: "Atención",
          message: "Tarea no pudo ser actualizada",
          type: "warning",
        });
      }
    },
    /* saveInventory() {
      this.saveLoading = true;
      this.$store.dispatch('createOrUpdateDraft').then((response) => {
        this.saveLoading = false;
        if (response.success) {
          this.$router.push({ name: 'summaryStep' });
          this.$notify.info({
            duration: 3000,
            title: 'Atención',
            message: 'Procedimiento registrado exitosamente',
          });
        } else {
          this.$alert(response.message, this.$t('Error'), {
            type: 'error',
          });
        }
      });
    }, */
    previousStep() {
      var tarea = this.$store.getters.inventario.tareas[this.$store.getters.selectedIndexTask];
      const indexTask = this.$store.getters.selectedIndexTask;
      this.$store.getters.inventario.tareas[indexTask].procedimiento = this.procedure;
      this.updateTask({ procedimiento: this.procedure }, tarea.id || tarea._id)
      this.$router.push({ name: 'firstStep' });
    },
    nextStep() {
      var tarea = this.$store.getters.inventario.tareas[this.$store.getters.selectedIndexTask];
      const indexTask = this.$store.getters.selectedIndexTask;
      this.$store.getters.inventario.tareas[indexTask].procedimiento = this.procedure;
      this.updateTask({ procedimiento: this.procedure }, tarea.id || tarea._id)
      this.$router.push({ name: 'summaryStep' });
      //this.saveInventory();
    },
    async setProcedure() {
      const indexTask = this.$store.getters.selectedIndexTask;
      this.procedure = this.$store.getters.inventario.tareas[indexTask].procedimiento;
    },
    async setProcedureRule() {
      this.rule = this.procedureRules[this.$store.getters.role.faena_id]
        || this.procedureRules.default;
    },
    async risksRuleValidation() {
      const indexTask = this.$store.getters.selectedIndexTask;
      this.$store.getters.inventario.tareas[indexTask].riesgos.forEach((r) => {
        const { mfl } = r.impactos[0];
        const rrr = r.impactos[0].factor_severidad * r.impactos[0].factor_probabilidad;
        if (mfl >= this.rule.mfl || rrr >= this.rule.rrr) {
          this.risksHigher.push({ nombre: r.nombre, mfl, rrr });
          this.required = true;
        }
      });
    },
    async setStatus() {
      this.status = (/\S/.test(this.procedure)
        && this.procedure !== null
        && this.procedure !== undefined);
    },
  },
};
</script>

<style>
.text-back {
  color: #000;
}

.p-20 {
  padding: 20px;
}

.mb-20 {
  margin-bottom: 20px;
}

.s-1 {
  font-size: 20px;
}
</style>

<style scoped>
.detalles-inventario {
  margin-bottom: 60px;
}

label {
  color: rgb(131, 138, 142);
  font-size: 14px;
}

.el-input {
  margin-top: 5px;
}
</style>
